export default __webpack_public_path__ + "static/media/img5.8c14046f.png";